import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IdName, Church } from 'src/core/models';
import { 
  AgeGroupService, ArrayService, AuthService, ChurchService, 
  DatabaseService, DocumentService, FestivalUserService 
} from 'src/core/services';
import { ModalController, AlertController, LoadingController } from '@ionic/angular';
import { AddChurchComponent } from '../add-church/add-church.component';
import { EditChurchComponent } from '../edit-church/edit-church.component';
import { PageClass } from 'src/core/classes/page';

@Component({
  selector: 'app-church-list',
  templateUrl: './church-list.component.html',
  styleUrls: ['./church-list.component.less', '../../core/styles/common.less']
})

export class ChurchListComponent extends PageClass implements OnInit {

  countryList: IdName[];
  
  filter: any = { filterCountry: undefined };

  isLoading = true;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private docService: DocumentService,
    private router: Router,
    protected festivalUserService: FestivalUserService,
    protected modalController: ModalController,
    protected alertController: AlertController,
    protected loadingController: LoadingController
  ) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      if (!this.currentUser.isAdmin) {
        this.router.navigate(['/']);
      } else {
        this.countryList = this.churchService.getCountryList();
        this.filter.filterCountry = this.countryList[0];

        await this.getCountryChurchList();
      }
    }
  }

  getCountryChurchList = async () => {
    this.churchService.getCountryChurchList(this.filter.filterCountry)
      .subscribe(churchList => {
        this.churchList = churchList.sort(this.arrayService.orderByDisplayName);
        this.isLoading = false;
      });
  }

  doRefresh = async (event) => {
    await this.getCountryChurchList();
    event.target.complete();
  }

  addChurch = async () => {
    const modal = await this.modalController.create({
      component: AddChurchComponent,
      componentProps: {
      }
    });
    return await modal.present();
  }

  editChurch = async (church: Church) => {
    const modal = await this.modalController.create({
      component: EditChurchComponent,
      componentProps: { church }
    });
    return await modal.present();
  }

  deleteChurch = (churchId: string) => {
    this.docService.deleteDocument(this.churchService.collection, churchId);
  }
}
